import React from "react";

export const AutoGenerateReport = React.lazy(
  () =>
    import("@/features/auto-generate-report/pages/AutoGenerateReportPage.tsx"),
);
